<template>
    <div
        id="header"
        class="clearfix"
    >
        <div
            id="logo"
            class="left"
        >老年大学网络报名</div>
        <div
            id="info"
            class="right"
        >
            <ul>
                <li class="msg">
                    <router-link :to="{ path: '/message' }">
                        <el-badge
                            :value="msg"
                            :max="99"
                            class="item"
                        >
                            <i class="msg-num"></i>
                        </el-badge>消息
                    </router-link>
                </li>
                <li class="user">
                    <span class="user-icon">
                        <img
                            :src="userinfo['photoImg']"
                            v-if="userinfo['photoImg']"
                        />
                        <img
                            src="@/assets/images/icon/default-avatar.png"
                            v-else
                        />
                    </span>
                    <el-dropdown trigger="click">
                        <span class="el-dropdown-link user-name">
                            {{ userinfo["name"]
                            }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="goToPath('personalinfo')">用户中心</el-dropdown-item>
                            <!-- <el-dropdown-item @click.native="goToPath('verify')" >实名认证</el-dropdown-item> -->
                            <el-dropdown-item @click.native="logout('')"><a @click="logout()">退出登录</a></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </li>
                <li class="logout">
                    <a @click="logout()"></a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import logo from "@/assets/images/logo.png";
import touxiang from "@/assets/images/icon/touxiang.png";

export default {
    data() {
        return {
            logo: logo,
            msg: 1, //消息数量
            userinfo: {
                headImage: null,
                name: null,
            },
            //用户信息
            user: {
                icon: logo,
                name: "11234567890",
            },
            userAuth: [],
        };
    },
    methods: {
        logout: async function () {
            let me = this;
            let res = await me.$userService.userOut();
            if (res && res["success"]) {
                window.sessionStorage.clear();
                me.$global.isagree = false;
                me.$router.push({ name: "login" });
            }
        },
        goToPath(path) {
            let me = this;
            me.$router.push({ name: path, query: { param: 1 } });
        },
        async updataInfo() {
            let me = this;
            let param = { id: "" };
            let userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(userinfo);
            if (userinfo) {
                param.id = userinfo.id;
                let res = await me.$team.queryStudentById(param);
                if (res && res["success"]) {
                    let userinfo = res.content;
                    me.userinfo = userinfo;
                    window.sessionStorage.setItem(
                        "userinfo",
                        JSON.stringify(userinfo)
                    );
                }
            }
        },
        async initLoad() {
            let me = this;
            let userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(userinfo);
            me.userinfo = userinfo;
            if (me.userinfo) {
                let res = await me.$userService.queryMsgCount();
                if (res && res["success"]) {
                    me.msg = res["content"];
                }
            } else {
                me.msg = 0;
                me.userinfo = {
                    headImage: null,
                    name: null,
                };
            }
            let userAuth = window.sessionStorage.getItem("userAuth");
            userAuth = JSON.parse(userAuth);
            me.userAuth = [];
            if (userAuth) {
            }
        },
    },
    async mounted() {
        let me = this;
        this.user.icon = touxiang;
        await this.updataInfo();
        await me.initLoad();
    },
    watch: {
        //监听路由，判断头部和菜单是否显示
        $route(to, from) {
            this.initLoad();
            this.updataInfo();
        },
    },
};
</script>
<style lang="scss">
#header {
    background-color: #ffffff;
    height: 60px;
    box-shadow: 0 2px 3px #e1eaf6;
    #logo {
        margin-left: 30px;
        height: 60px;
        line-height: 60px;
        font-size: 24px;
        img {
            width: 227px;
            height: 49px;
        }
    }
    #info {
        ul {
            margin: 0;
            padding: 10px 0;
            list-style: none;
            li {
                font-size: 14px;
                line-height: 40px;
                height: 40px;
                padding: 0 10px;
                display: inline-block;
                &.help {
                    background: url("../../assets/images/icon/help.png")
                        no-repeat 0 10px;
                    padding-left: 25px;
                }
                &.msg {
                    i.msg-num {
                        line-height: 20px;
                        background: url("../../assets/images/icon/msg.png")
                            no-repeat 0 1px;
                        width: 20px;
                        height: 20px;
                        margin: 10px 10px 0 0;
                        padding: 0;
                        display: inline-block;
                    }
                    .el-badge__content.is-fixed {
                        top: 10px;
                        right: 20px;
                        padding: 0 3px;
                        border-radius: 3px;
                    }
                }
                &.user {
                    .user-icon img {
                        vertical-align: middle;
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        object-fit: cover;
                    }
                }
                &.logout a {
                    background: url("../../assets/images/icon/logout.png")
                        no-repeat 0 0;
                    width: 20px;
                    height: 20px;
                    display: inline-block;
                    vertical-align: middle;
                    cursor: pointer;
                }
                a,
                a:hover {
                    color: #2c3e50;
                    text-decoration: none;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue